import React, { useState, useRef, useEffect } from "react";

import { useClientContext } from '../contexts/ClientContext.js';

import Dropdown from "./Dropdown.js";

import { useOrderContext } from '../contexts/OrderContext.js';
import { useProjectContext } from '../contexts/ProjectContext.js';
import axios from 'axios';
import useFetchDropdownOptions from "../hooks/UseFetchDropdownOptions.js";
import useCurrentYearMonth from "../hooks/useCurrentYearMonth.js";
import { api } from "../apiClient.js";

function CreateOrder() {
  const {
    orderData,
    updateOrderData,
    orderStatus,
    setOrderStatus,
  } = useOrderContext();

  const {
    projectData,
    updateProjectData,
    projectStatus,
    setProjectStatus,
  } = useProjectContext();

  const { yearLastTwoDigits, monthTwoDigits } = useCurrentYearMonth();

  const [lastTwoDigits, setLastTwoDigits] = useState('01');
  // 從後端獲取新的最後兩位數字
  const fetchNextCaseNumber = async () => {
    try {
      const response = await fetch('http://localhost:5000/get_next_case_no');
      const data = await response.json();
      if (data.next_number) {
        setLastTwoDigits(data.next_number);
      }
    } catch (error) {
      console.error('Error fetching next case number:', error);
    }
  };
  useEffect(() => {
    fetchNextCaseNumber();
  }, []);


  // const [clientEnOptions, setClientEnOptions] = useState([]);
  // const [selectedClientEn, setSelectedClientEn] = useState('');

  // useEffect(() => {
  //   // 從後端 API 獲取 case_no 資料
  //   const fetchClientEn = async () => {
  //     try {
  //       const response = await fetch('http://localhost:5000/get_client_en');
  //       const data = await response.json();
  //       if (data.client_en) {
  //         // 將 case_no 轉換為帶 value 和 label 的結構
  //         const options = data.client_en.map((clientEn) => ({
  //           value: clientEn.slice(0,3),
  //           label: clientEn.slice(0,3),
  //         }));
  //         setClientEnOptions(options);
  //       }
  //     } catch (error) {
  //       console.error('Error fetching client_en:', error);
  //     }
  //   };

  //   fetchClientEn();
  // }, []);

  // const handleClientEnChange = (e) => {
  //   setSelectedClientEn(e.target.value);
  // };


  const {
    ClientEnOptions, // 動態生成的 options 狀態
    setClientEnOptions, // 動態生成的狀態 setter
    SelectedClientEn, // 動態生成的選中值狀態
    setSelectedClientEn, // 動態生成的選中值 setter
    handleOptionChange, // 動態生成的 change 處理函式
  } = useFetchDropdownOptions({
    apiUrl: 'http://localhost:5000/get_client_alias', // API 路徑
    optionKey: 'value',      // 下拉選單選項的值名稱
    labelKey: 'label',       // 下拉選單顯示文字的名稱
    dataKey: 'client_en',    // API 回應中數據的鍵名稱
    defaultOptionsName: 'ClientEnOptions', // 自定義 options 名稱
    defaultSelectedName: 'SelectedClientEn', // 自定義選中值名稱,
    transformItem: (item) => ({
      value: item.slice(0, 2).toUpperCase(),
      label: item.slice(0, 2).toUpperCase(),
    }),
  });



  const handleSubmit = async (e) => {
    e.preventDefault();
    // 收集所有表單數據
    const formOrderData = {
      case_name: e.target.case_name.value,
      case_no: `${SelectedClientEn}${yearLastTwoDigits}${monthTwoDigits}${selectedAB}${lastTwoDigits}`,
      house: selectedHouse,
      // resolution: selectedResolution,
      // format: selectedFormat,
      // ratio: "16:9",
      // sec: selectedSec,
    };
    console.log(formOrderData);

    // 一次性更新 clientData
    updateOrderData(formOrderData);

    // const formProjectData = {
    //   case_no: e.target.case_no.value,
    //   house: selectedHouse,
    //   resolution: selectedResolution,
    //   format : selectedFormat,
    //   ratio: "16:9",
    //   sec: selectedSec,
    // };

    // 為每個 project 添加 case_no
    const updatedProjects = projects.map((project) => ({
      ...project,
      case_name: formOrderData.case_name,
      case_no: formOrderData.case_no, // 動態添加 case_no
    }));

    updateProjectData(updatedProjects);

    console.log(orderData);
    console.log(projectData);


    const payloadOrder = new FormData();
    payloadOrder.append("case_name", formOrderData.case_name);
    payloadOrder.append("case_no", formOrderData.case_no);
    payloadOrder.append("house", formOrderData.house);
    // payloadOrder.append("resolution", formOrderData.resolution);
    // payloadOrder.append("format", formOrderData.format);
    // payloadOrder.append("ratio", formOrderData.ratio);
    // payloadOrder.append("sec", formOrderData.sec);


    const payloadProject = new FormData();
    // 遍歷 `updatedProjects`，只添加 `name` 不為空的項目
    updatedProjects.forEach((project, index) => {
      if (project.project_name) {
        Object.keys(project).forEach((key) => {
          payloadProject.append(`projects[${index}][${key}]`, project[key]);
        });
      }
    });


    try {
      // setUploadStatus("上傳中...");
      // const orderResponse = await axios.post(
      const orderResponse = await api.post(
        "/create-order",
        payloadOrder, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      // ✅ 從 response 拿到 order_id
      const order_id = orderResponse.data.order_id;

      // ✅ 將 order_id 加進每一筆 project
      const updatedProjectsWithOrderId = updatedProjects.map((project) => ({
        ...project,
        order_id: order_id,
      }));

      const payloadProject = new FormData();
      updatedProjectsWithOrderId.forEach((project, index) => {
        if (project.project_name) {
          Object.keys(project).forEach((key) => {
            payloadProject.append(`projects[${index}][${key}]`, project[key]);
          });
        }
      });

      // const projectResponse = await axios.post(
      const projectResponse = await api.post(
        "/create-projects",
        payloadProject, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      // const taskResponse = await axios.post(
      const taskResponse = await api.post(
        "/create-tasks",
        payloadProject, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      // const quotationResponse = await axios.post(
      const quotationResponse = await api.post(
        "/create_quotation",
        payloadOrder, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        responseType: "blob",  // 告訴 axios 回傳的是二進位 Word 檔案
      });
      // 將二進位資料轉為可下載的 Blob 並觸發下載
      const blob = new Blob([quotationResponse.data], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      link.download = `${formOrderData.case_name}_quotation.docx`;  // 自訂下載檔名
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);  // 清理記憶體






      if (projectResponse.status === 200) {
        console.log('上傳成功！');
        // 上傳成功後執行 fetchNextCaseNumber
        await fetchNextCaseNumber();
      }
      // setUploadStatus("上傳成功！");

      e.target.reset();
      alert("資料已提交");
    } catch (error) {
      console.error("上傳失敗:", error);
      // setUploadStatus("上傳失敗！");
    }
  };


  // 選單選項

  // 建立年份範圍，例如 2025 到 2035
  const yearOptions = Array.from({ length: 10 }, (_, i) => {
    const value = 25 + i;
    return { value: value.toString(), label: value.toString() };
  });
  // 月份列表
  const [monthOptions, setMonthOptions] = useState([
    { value: "01", label: "01" },
    { value: "02", label: "02" },
    { value: "03", label: "03" },
    { value: "04", label: "04" },
    { value: "05", label: "05" },
    { value: "06", label: "06" },
    { value: "07", label: "07" },
    { value: "08", label: "08" },
    { value: "09", label: "09" },
    { value: "10", label: "10" },
    { value: "11", label: "11" },
    { value: "12", label: "12" },
  ]);
  const [houseOptions, setHouseOptions] = useState([
    { value: "一一", label: "一一" },
    { value: "十十", label: "十十" },
  ]);
  const [categoryOptions, setCategoryOptions] = useState(
    [
      { value: "主視覺＋介紹", label: "主視覺＋介紹" },
      { value: "提案", label: "提案" },
      { value: "沈浸式", label: "沈浸式" },
      { value: "3D動畫", label: "3D動畫" },
      { value: "3D平面", label: "3D平面" },
      { value: "建模", label: "建模" },
      { value: "順接影片", label: "順接影片" },
      { value: "投映影片", label: "投映影片" },
      { value: "2D動畫", label: "2D動畫" },
      { value: "活動專案", label: "活動專案" },
      { value: "主視覺", label: "主視覺" },
      { value: "濾鏡", label: "濾鏡" },
      { value: "文字動畫", label: "文字動畫" },
      { value: "Award", label: "Award" },
    ]);
  const [resolutionOptions, setResolutionOptions] = useState(
    [
      { value: "1920x1080", label: "1920x1080" },
      { value: "1080x1920", label: "1080x1920" },
      { value: "800x1000", label: "800x1000" },
    ]);
  const [formatOptions, setFormatOptions] = useState([
    { value: "MP4", label: "MP4" },
    { value: "MOV", label: "MOV" },
    { value: "JPG", label: "JPG" },
    { value: "PNG", label: "PNG" },
    { value: "GIF", label: "GIF" },
  ]);
  const [ratioOptions, setRatioOptions] = useState(
    [
      { value: "16:9", label: "16:9" },
      { value: "3:4", label: "3:4" },
      { value: "4:5", label: "4:5" },
    ]);
  const [secOptions, setSecOptions] = useState([
    { value: "15s", label: "15s" },
    { value: "30s", label: "30s" },
  ]);
  const [projectStatusOptions, setProjectStatusOptions] = useState([
    { value: "Not started", label: "Not started" },
    { value: "A Copy", label: "A Copy" },
    { value: "B Copy", label: "B Copy" },
    { value: "C Copy", label: "C Copy" },
    { value: "Completed", label: "Completed" },
    { value: "Script", label: "Script" },
  ]);
  const [assigneeOptions, setAssigneeOptions] = useState([
    { value: "JJ", label: "JJ" },
    { value: "Minda", label: "Minda" },
    { value: "Sean", label: "Sean" },
    { value: "Jasmine", label: "Jasmine" },
    { value: "JiaJing", label: "JiaJing" },
    { value: "Gao", label: "Gao" },
    { value: "Fish", label: "Fish" },
  ]);

  // 狀態管理
  // const [caseName, setCaseName] = useState("");
  const [selectedAB, setSelectedAB] = useState("A"); // 預設為第一個年份
  const [selectedYear, setSelectedYear] = useState(yearOptions[0].value); // 預設為第一個年份
  const [selectedMonth, setSelectedMonth] = useState(monthOptions[0].value); // 預設為第一個月份
  const [selectedHouse, setSelectedHouse] = useState(houseOptions[0].value);
  const [selectedResolution, setSelectedResolution] = useState(resolutionOptions[0].value);
  const [selectedSec, setSelectedSec] = useState(secOptions[0].value);
  const [selectedFormat, setSelectedFormat] = useState(formatOptions[0].value);
  // const [selectedProjectStatus, setSelectedProjectStatus] = useState(projectStatusOptions[0]);
  // const [selectedAssignee, setSelectedAssignee] = useState(assigneeOptions[0]);


  // // 處理年份變更
  // const handleYearChange = (value) => {
  //   setSelectedYear(value);
  // };
  // // 處理月份變更
  // const handleMonthChange = (value) => {
  //   setSelectedMonth(value);
  // };
  const handleHouseChange = (value) => {
    setSelectedHouse(value);
    if (value == "一一") setSelectedAB("A");
    else setSelectedAB("B");
    console.log(selectedAB);
  };
  // const handleResolutionChange = (newValue) => {
  //   setSelectedResolution(newValue);
  //   // // **當用戶新增解析度時，確保父組件也能更新**
  //   // if (!resolutionOptions.some(option => option.value === newValue)) {
  //   //   setResolutionOptions([...resolutionOptions, { value: newValue, label: newValue }]);
  //   // }

  //   // ✅ 確保 `resolutionOptions` 最新，防止重複新增
  //   setResolutionOptions(prevOptions => {
  //     if (!prevOptions.some(option => option.value === newValue)) {
  //       return [...prevOptions, { value: newValue, label: newValue }];
  //     }
  //     return prevOptions;
  //   });
  // };
  // const handleSecChange = (newValue) => {
  //   setSelectedSec(newValue);
  //   setSecOptions(prevOptions => {
  //     if (!prevOptions.some(option => option.value === newValue)) {
  //       return [...prevOptions, { value: newValue, label: newValue }];
  //     }
  //     return prevOptions;
  //   });
  // };
  // const handleFormatChange = (newValue) => {
  //   setSelectedFormat(newValue);
  //   // ✅ 確保 `resolutionOptions` 最新，防止重複新增
  //   setFormatOptions(prevOptions => {
  //     if (!prevOptions.some(option => option.value === newValue)) {
  //       return [...prevOptions, { value: newValue, label: newValue }];
  //     }
  //     return prevOptions;
  //   });
  // };
  // const handleProjectStatusChange = (value) => {
  //   setSelectedProjectStatus(value);
  // };
  // const handleAssigneeChange = (value) => {
  //   setSelectedAssignee(value);
  // };



  const [projects, setProjects] = useState([
    {
      id: Date.now(),
      case_name: orderData.case_name,
      case_no: orderData.case_no,
      project_name: "",
      category: "主視覺＋介紹",
      resolution: "1920x1080",
      format: "MP4",
      ratio: "16:9",
      sec: "15s",
      due_date: "",
      status: "Not started",
      description: "",
      assignee: "JJ"
    },]);

  const addProject = () => {
    setProjects([
      ...projects,
      {
        id: Date.now(),
        case_name: orderData.case_name,
        case_no: orderData.case_no,
        project_name: "",
        category: "主視覺＋介紹",
        resolution: "1920x1080(橫式)",
        format: "MP4",
        ratio: "16:9",
        sec: "15s",
        due_date: "",
        status: "Not started",
        description: "",
        assignee: "JJ"
      },
    ]);
  };

  const handleProjectChange = (id, field, value) => {
    setProjects((prevProjects) =>
      prevProjects.map((project) =>
        project.id === id ? { ...project, [field]: value } : project
      )
    );
    console.log(projects);
  };

  return (
    <>
      <div className='sidebar-header'>— Order —</div>
      <form
        onSubmit={handleSubmit}
        className='sidebar-form'
      >
        <div className='sidebar-block'>
          <div className="blue-block">
            <img src='./order.png' style={{ width: "7%" }}></img>
            Order
          </div>
          <div
            className='block-row'
          >
            <label>
              Case Name:
            </label>
            <input
              type="text" id="case_name" name="case_name" placeholder="Enter case name"
            />
          </div>
          <div className="block-row">
            <label>
              House:
            </label>
            <Dropdown
              // label="House: "
              name="house"
              options={houseOptions}
              value={selectedHouse}
              onChange={handleHouseChange}
              setOptions={setHouseOptions}
              block="order-doropdown"
            />
          </div>
          <div className="block-row">
            <label>
              Case No:
            </label>
            <Dropdown
              label=""
              name="client_en"
              options={ClientEnOptions}
              value={SelectedClientEn}
              onChange={handleOptionChange}
              setOptions={setClientEnOptions}
              block="order-doropdown"
            />
          </div>
          <div style={{color:"#0043C8", paddingLeft:"100px"}}>
            {yearLastTwoDigits}{monthTwoDigits}
            {selectedHouse === "一一" ? "A" : "B"}
            {lastTwoDigits}
          </div>
        </div>

        {/* <Dropdown
            label=""
            name="year"
            options={yearOptions}
            value={selectedYear}
            onChange={handleYearChange}
          />
          <Dropdown
            label=""
            name="month"
            options={monthOptions}
            value={selectedMonth}
            onChange={handleMonthChange}
          /> */}
        {/* <Dropdown
          label="Resolution: "
          name="resolution"
          options={resolutionOptions}
          value={selectedResolution}
          onChange={handleResolutionChange}
        />
        <br />
        <Dropdown
          label="Format: "
          name="format"
          options={formatOptions}
          value={selectedFormat}
          onChange={handleFormatChange}
        />
        <br />
        <div>Ratio: 16:9</div>
        <Dropdown
          label="Sec: "
          name="sec"
          options={secOptions}
          value={selectedSec}
          onChange={handleSecChange}
        />
        <br /> */}

        {/*         
        <div>Project:</div>
        <label>Name:
          <input type="text" id="project_name" name="project_name" placeholder="Enter project name" />
        </label>
        <br />
        <label>Due date:
          <input type="date" id="due_date" name="due_date" placeholder="Enter due date" />
        </label>
        <br />
        <Dropdown
          label="Status: "
          name="status"
          options={projectStatusOptions}
          value={selectedProjectStatus}
          onChange={handleProjectStatusChange}
        />
        <br />
        <label>Description:
          <input type="text"></input>
        </label>
        <br />
        <Dropdown
          label="Assignee: "
          name="assignee"
          options={assigneeOptions}
          value={selectedAssignee}
          onChange={handleAssigneeChange}
        />
        <br /> */}




        {projects.map((project, index) => (
          <div key={project.id} className='sidebar-form'>
            <div className='sidebar-block order-project'>
              <div className="green-block">Project<span>{index + 1}</span></div>
              <div
                className='block-row'
              >
                <label>
                  Project Name:
                </label>
                <input
                  type="text"
                  value={project.project_name}
                  onChange={(e) => handleProjectChange(project.id, "project_name", e.target.value)}
                  placeholder="Enter project name"
                />
              </div>
              <div className="block-row">
                <label>
                  Category:
                </label>
                <Dropdown
                  label="Category: "
                  name="category"
                  options={categoryOptions}
                  value={project.category}
                  onChange={(value) => handleProjectChange(project.id, "category", value)}
                  setOptions={setCategoryOptions}
                  block="order-doropdown"
                />
              </div>
              <div className="block-row">
                <label>
                  Resolution:
                </label>
                <Dropdown
                  label="Resolution: "
                  name="resolution"
                  options={resolutionOptions}
                  value={project.resolution}
                  onChange={(value) => handleProjectChange(project.id, "resolution", value)}
                  setOptions={setResolutionOptions}
                  block="order-doropdown"
                />
              </div>
              <div className="block-row">
                <label>
                  Format:
                </label>
                <Dropdown
                  label="Format: "
                  name="format"
                  options={formatOptions}
                  value={project.format}
                  onChange={(value) => handleProjectChange(project.id, "format", value)}
                  setOptions={setFormatOptions}
                  block="order-doropdown"
                />
              </div>
              {/* <div>
                <img src='./ratio.png' style={{ width: "7%" }}></img>
                Ratio: 16:9</div> */}
              <div className="block-row">
                <label>
                  Ratio:
                </label>
                <Dropdown
                  label="Ratio: "
                  name="ratio"
                  options={ratioOptions}
                  value={project.ratio}
                  onChange={(value) => handleProjectChange(project.id, "ratio", value)}
                  setOptions={setRatioOptions}
                  block="order-doropdown"
                />
              </div>
              <div className="block-row">
                <label>
                  Sec:
                </label>
                <Dropdown
                  label="Sec: "
                  name="sec"
                  options={secOptions}
                  value={selectedSec}
                  onChange={(value) => handleProjectChange(project.id, "sec", value)}
                  setOptions={setSecOptions}
                  block="order-doropdown"
                />
              </div>
              <div
                className='block-row'
              >
                <label>
                  Due Date:
                </label>
                <input
                  type="date"
                  value={project.due_date}
                  onChange={(e) => handleProjectChange(project.id, "due_date", e.target.value)}
                />
              </div>
              {/* <Dropdown
              label="Status: "
              name="status"
              options={projectStatusOptions}
              value={project.status}
              onChange={(value) => handleProjectChange(project.id, "status", value)}
            /> */}
              <div
                className='block-row'
              >
                <label>
                  Description:
                </label>
                <input
                  type="text"
                  value={project.description}
                  onChange={(e) => handleProjectChange(project.id, "description", e.target.value)}
                  placeholder="Enter description"
                />
              </div>
              <div className="block-row">
                <label>
                  Assignee:
                </label>
                <Dropdown
                  label="Assignee: "
                  name="assignee"
                  options={assigneeOptions}
                  value={project.assignee}
                  onChange={(value) => handleProjectChange(project.id, "assignee", value)}
                  setOptions={setAssigneeOptions}
                  block="order-doropdown"
                />
              </div>
            </div>
          </div>
        ))}
        <button
          className="green-button add-button"
          type="button"
          onClick={addProject}
        >
          <img src='./add.png' style={{ width: "30%" }}></img>
          <div>ADD</div>
        </button>

        <button className="orange-button" type="submit">
          <img src='./arrow03.png' style={{ width: "30%" }}></img>
          Submit
        </button>
        <br />
      </form>
    </>
  )
}

export default CreateOrder;
